import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { buyRespRootQuery } from '../../queries/buyRespRoot';
import { BuySharedLayout } from '../../buy/BuySharedLayout';
import { createEntry } from '../createEntry';

import { defaultReducers } from '../../reducers/reducerUtils';
import { sbSharedReducers } from '../../reducers/sbSharedReducers';
const options = {
    reducers: {
        ...defaultReducers,
        ...sbSharedReducers,
    },
};

initializeDBL(options).then(({ store }) => {
    createEntry({
        Container: BuySharedLayout,
        store,
        query: buyRespRootQuery,
    });
});
